export default "__VITE_ASSET__3ad03502__"